import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Form, Input, Button, Select, DatePicker, Row, Col } from "antd";
import {
  emptyErrorObj,
  resetSubmitLeadRemarkss,
  submitLeadRemarks,
} from "../../actionCreator/leadDetailsActionCreator";
import { SAVE_CLIENT_REMARKS_ERROR } from "../../actionType/leadDetailsType";
import { useAlert } from "../../context/AlertProvider";
import ActivityTime from "./ActivityTime";

const { TextArea } = Input;

const Tasks = ({ setActiveTab }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [task, setTask] = useState();

  const errObj = useSelector((state) => state.LeadDetailsReducer.errObj);
  const leadDetail = useSelector(
    (state) => state.LeadDetailsReducer.leadDetails
  );
  const leadRemarksSubmitted = useSelector(
    (state) => state.LeadDetailsReducer.saveleadRemarks
  );
  const leadRemarksDetails = useSelector(
    (state) => state.LeadDetailsReducer.leadRemarksDetails
  );

  useEffect(() => {
    if (!!Object.keys(errObj).length) {
      showAlert("error", errObj[SAVE_CLIENT_REMARKS_ERROR]?.message);
      dispatch(resetSubmitLeadRemarkss());
      dispatch(emptyErrorObj());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errObj]);

  useEffect(() => {
    if (Object.keys(leadRemarksSubmitted).length) {
      showAlert("success", "Remarks Submitted.");
      form.resetFields();
      setTask();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leadRemarksSubmitted, form]);

  useEffect(() => {
    if (!Object.keys(leadRemarksDetails).length) return;
    form.setFieldsValue({
      title: leadRemarksDetails.title,
      status: leadRemarksDetails.status,
      remarks: leadRemarksDetails.remarks,
      interactionDate: moment(leadRemarksDetails.interactionDate),
    });
    setTask(leadRemarksDetails.title);
  }, [leadRemarksDetails, form]);

  const onFinish = (values) => {
    const formattedDate =
      values.interactionDate.format("YYYY-MM-DDTHH:mm:ss") + "Z";
    const payload = {
      remarks: values.remarks,
      interactionDate: formattedDate,
      isContactBackRequired: false,
      isContacted: false,
      isToDisplay: values.status === "open",
      status: values.status,
      title: values.title,
      lead: leadDetail,
      update: !!Object.keys(leadRemarksDetails).length,
      id: leadRemarksDetails?.id || "",
    };
    dispatch(submitLeadRemarks(payload));
  };

  const redirectToTimline = () => {
    setActiveTab("1");
    form.resetFields();
    setTask();
  };

  return (
    <>
      <div className="p-20">
        <h3 className="heading24px mb30 fw-semibold text-color-1C1C1C">
          Add/Edit Task
        </h3>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={[24, 0]}>
            <Col span={24}>
              <Form.Item
                label={<label className="fw-medium">Select Task</label>}
                name="title"
                className="mb15"
                rules={[{ required: true, message: "Please select task" }]}
              >
                <div className="d-flex gap-10 align-items-center">
                  <div
                    className={`w-42 h-42 activity-icon task-icons heading20px rounded-circle ${task === "call" && "task-active"}`}
                    onClick={() => {
                      setTask("call");
                      form.setFieldsValue({ title: "call" });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.001"
                      height="18.001"
                      viewBox="0 0 18.001 18.001"
                    >
                      <path
                        id="call-incoming_5070414"
                        d="M17.341,12.6a2.329,2.329,0,0,1,0,3.289l-.685.789C10.5,22.565-4.47,7.6,1.329,1.425L2.193.674A2.315,2.315,0,0,1,5.444.7c.023.023,1.415,1.832,1.415,1.832a2.336,2.336,0,0,1,0,3.217l-.87,1.094a9.6,9.6,0,0,0,5.207,5.218l1.1-.875a2.329,2.329,0,0,1,3.216,0s1.81,1.392,1.833,1.415Zm-1.033,1.092s-1.8-1.384-1.821-1.406a.826.826,0,0,0-1.164,0c-.02.02-1.536,1.228-1.536,1.228a.751.751,0,0,1-.736.114,11.276,11.276,0,0,1-6.63-6.62.751.751,0,0,1,.109-.751S5.739,4.742,5.759,4.723a.826.826,0,0,0,0-1.164c-.023-.023-1.406-1.822-1.406-1.822a.826.826,0,0,0-1.134.029l-.864.751c-4.239,5.1,8.737,17.352,13.2,13.135l.685-.79A.841.841,0,0,0,16.308,13.691Z"
                        transform="translate(-0.019 -0.022)"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div
                    className={`w-42 h-42 activity-icon task-icons heading20px rounded-circle ${task === "email" && "task-active"}`}
                    onClick={() => {
                      setTask("email");
                      form.setFieldsValue({ title: "email" });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19.967"
                      height="14.975"
                      viewBox="0 0 19.967 14.975"
                      fill="currentColor"
                    >
                      <g transform="translate(-10.66 -31.98)">
                        <path
                          d="M29.379,31.98H11.908a1.248,1.248,0,0,0-1.248,1.248V45.707a1.248,1.248,0,0,0,1.248,1.248H29.379a1.248,1.248,0,0,0,1.248-1.248V33.228A1.248,1.248,0,0,0,29.379,31.98Zm-.961,13.727H12.944l4.368-4.517-.9-.867-4.5,4.661V34.176l7.756,7.718a1.248,1.248,0,0,0,1.76,0l7.955-7.912V44.9L24.786,40.31l-.88.88ZM12.725,33.228H28.368l-7.824,7.781Z"
                          fill="currentColor"
                        />
                      </g>
                    </svg>
                  </div>
                  <div
                    className={`w-42 h-42 activity-icon task-icons heading20px rounded-circle ${task === "meeting" && "task-active"}`}
                    onClick={() => {
                      setTask("meeting");
                      form.setFieldsValue({ title: "meeting" });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20.218"
                      height="16.702"
                      viewBox="0 0 20.218 16.702"
                      fill="currentColor"
                    >
                      <defs>
                        <clipPath id="clip-path">
                          <rect width="20.218" height="16.702" fill="none" />
                        </clipPath>
                      </defs>
                      <g clipPath="url(#clip-path)">
                        <path
                          d="M218.782,17.755c-.088-.088-.088-.088-.176-.088l-3.868-1.231a2.789,2.789,0,0,0-2.813.616,1.936,1.936,0,0,0-.352.439l-1.758,4.044a1.583,1.583,0,0,0,.176.879,1.513,1.513,0,0,0,1.055.879,1.772,1.772,0,0,0,1.582-.527,1.227,1.227,0,0,0,.264-.352l.615-1.055c.088-.176.264-.352.352-.527.527-.527.7-.264.791-.176.879.791,5.362,5.362,5.362,5.362a.544.544,0,0,1-.088.7.532.532,0,0,1-.7.088l-1.231-1.231a.435.435,0,0,0-.616.615l1.231,1.231a.544.544,0,0,1-.088.7.532.532,0,0,1-.7.088L216.672,26.9a.435.435,0,0,0-.616.615l1.231,1.231a.46.46,0,0,1-.176.7.753.753,0,0,1-.616,0l-1.231-1.231a.435.435,0,1,0-.615.615l1.231,1.231a.461.461,0,0,1-.176.7.751.751,0,0,1-.615,0l-1.582-1.582a.832.832,0,0,0-.176-1.142.854.854,0,0,0-1.231-.088.673.673,0,0,0,.176-1.142.854.854,0,0,0-1.231-.088.942.942,0,0,0-1.318-1.318.849.849,0,0,0-.088-1.231.934.934,0,0,0-1.231-.088l-2.549-2.637a.435.435,0,0,0-.616.615l2.549,2.461-.7.7a.942.942,0,0,0,1.318,1.318.942.942,0,0,0,1.318,1.318.942.942,0,0,0,1.318,1.318.942.942,0,0,0,1.318,1.319l.791-.791,1.582,1.494a1.275,1.275,0,0,0,1.846-.088,1.681,1.681,0,0,0,.439-.879,1.418,1.418,0,0,0,1.318-1.318,1.082,1.082,0,0,0,.879-.439,1.221,1.221,0,0,0,.439-.88,1.081,1.081,0,0,0,.879-.439,1.359,1.359,0,0,0,.088-1.846l-.615-.616,2.637-2.637a.424.424,0,0,0,0-.615Zm6.329.879-3.428-3.429a.851.851,0,0,0-1.231,0l-1.231,1.143a.75.75,0,0,0,0,1.143l3.428,3.428a.85.85,0,0,0,1.231,0l1.231-1.055a.85.85,0,0,0,0-1.231m-1.758,1.758a.7.7,0,1,1,.7-.7.756.756,0,0,1-.7.7"
                          transform="translate(-205.157 -15.03)"
                          fill="currentColor"
                        />
                      </g>
                    </svg>
                  </div>
                  <div
                    className={`w-42 h-42 activity-icon task-icons heading20px rounded-circle ${task === "followup" && "task-active"}`}
                    onClick={() => {
                      setTask("followup");
                      form.setFieldsValue({ title: "followup" });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.352"
                      height="16.823"
                      viewBox="0 0 18.352 16.823"
                    >
                      <path
                        id="display-code_8778036"
                        d="M13.857,6.26a2.3,2.3,0,0,1,0,3.244L11.881,11.48A.765.765,0,0,1,10.8,10.4l1.975-1.976a.765.765,0,0,0,0-1.081L10.8,5.366a.765.765,0,0,1,1.081-1.081L13.857,6.26Zm-6.3-.895A.765.765,0,0,0,6.471,4.284L4.5,6.26A2.3,2.3,0,0,0,4.5,9.5L6.471,11.48A.765.765,0,0,0,7.552,10.4L5.577,8.423a.765.765,0,0,1,0-1.081L7.552,5.366Zm10.8-.542v6.117a3.828,3.828,0,0,1-3.823,3.823H9.941v1.529H13a.765.765,0,1,1,0,1.529H5.353a.765.765,0,1,1,0-1.529H8.411V14.764H3.823A3.828,3.828,0,0,1,0,10.941V4.823A3.828,3.828,0,0,1,3.823,1H14.529A3.828,3.828,0,0,1,18.352,4.823Zm-1.529,0a2.3,2.3,0,0,0-2.294-2.294H3.823A2.3,2.3,0,0,0,1.529,4.823v6.117a2.3,2.3,0,0,0,2.294,2.294H14.529a2.3,2.3,0,0,0,2.294-2.294Z"
                        transform="translate(0 -1)"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div
                    className={`w-42 h-42 activity-icon task-icons heading20px rounded-circle ${task === "chat" && "task-active"}`}
                    onClick={() => {
                      setTask("chat");
                      form.setFieldsValue({ title: "chat" });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.932"
                      height="16.734"
                      viewBox="0 0 17.932 16.734"
                    >
                      <g id="chat-dots" transform="translate(0 -12)">
                        <g
                          id="Group_340"
                          data-name="Group 340"
                          transform="translate(0 12)"
                        >
                          <path
                            id="Path_1894"
                            data-name="Path 1894"
                            d="M38.241,85.121A1.121,1.121,0,1,1,37.121,84,1.121,1.121,0,0,1,38.241,85.121Zm4.483,0A1.121,1.121,0,1,1,41.6,84,1.121,1.121,0,0,1,42.724,85.121Zm3.362,1.121a1.121,1.121,0,1,0-1.121-1.121A1.121,1.121,0,0,0,46.087,86.241Z"
                            transform="translate(-32.638 -77.276)"
                            fill="currentColor"
                          />
                          <path
                            id="Path_1895"
                            data-name="Path 1895"
                            d="M2.426,28.59l.022,0a15.3,15.3,0,0,0,3.887-1.238,10.154,10.154,0,0,0,2.63.343c4.951,0,8.966-3.512,8.966-7.845S13.917,12,8.966,12,0,15.512,0,19.845A7.28,7.28,0,0,0,2.208,25a11.7,11.7,0,0,1-.587,2.6l0,.012q-.125.361-.273.714a.292.292,0,0,0,.306.406q.389-.064.777-.14Zm.9-3.483a1.121,1.121,0,0,0-.322-.9,6.164,6.164,0,0,1-1.881-4.364c0-3.577,3.367-6.724,7.845-6.724s7.845,3.147,7.845,6.724-3.367,6.724-7.845,6.724a9.033,9.033,0,0,1-2.34-.3,1.121,1.121,0,0,0-.8.083,13.258,13.258,0,0,1-2.952,1,12.294,12.294,0,0,0,.446-2.241Z"
                            transform="translate(0 -12)"
                            fill="currentColor"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div
                    className={`w-42 h-42 activity-icon task-icons heading20px rounded-circle ${task === "whatsapp" && "task-active"}`}
                    onClick={() => {
                      setTask("whatsapp");
                      form.setFieldsValue({ title: "whatsapp" });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16.972"
                      height="17.049"
                      viewBox="0 0 16.972 17.049"
                    >
                      <g id="whatsapp" transform="translate(0 0.001)">
                        <g
                          id="Group_341"
                          data-name="Group 341"
                          transform="translate(0 -0.001)"
                        >
                          <path
                            id="Path_1896"
                            data-name="Path 1896"
                            d="M14.493,2.478A8.369,8.369,0,0,0,8.518,0,8.454,8.454,0,0,0,1.194,12.67L0,17.048l4.48-1.174A8.453,8.453,0,0,0,8.518,16.9h0A8.446,8.446,0,0,0,14.492,2.478ZM8.518,15.472a7,7,0,0,1-3.576-.98l-.256-.153-2.657.7.71-2.592-.166-.267a7.019,7.019,0,1,1,5.946,3.3Zm3.852-5.257c-.21-.105-1.247-.616-1.442-.688s-.336-.105-.474.105-.547.688-.668.826-.247.158-.458.053a5.764,5.764,0,0,1-1.7-1.05A6.442,6.442,0,0,1,6.456,8c-.121-.211-.012-.324.094-.429s.21-.247.315-.369a1.347,1.347,0,0,0,.211-.352.393.393,0,0,0-.016-.37c-.053-.105-.474-1.147-.652-1.566s-.344-.357-.474-.362-.263-.007-.4-.007a.777.777,0,0,0-.564.263A2.366,2.366,0,0,0,4.229,6.57a4.09,4.09,0,0,0,.863,2.183,9.385,9.385,0,0,0,3.6,3.188,11.744,11.744,0,0,0,1.2.445,2.9,2.9,0,0,0,1.328.085,2.187,2.187,0,0,0,1.426-1,1.767,1.767,0,0,0,.121-1c-.052-.09-.194-.142-.4-.247Z"
                            transform="translate(0 0.001)"
                            fill="currentColor"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<label className="fw-medium">Status</label>}
                name="status"
                className="mb15"
                rules={[{ required: true, message: "Please select a status" }]}
              >
                <Select
                  showSearch
                  placeholder="Select task status"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    { value: "open", label: "Open" },
                    { value: "re-scheduled ", label: "Re-scheduled " },
                    { value: "cancelled ", label: "Cancelled " },
                    { value: "completed ", label: "Completed " },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label={<label className="fw-medium">Date and Time</label>}
                name="interactionDate"
                className="mb15"
                rules={[
                  { required: true, message: "Please select a date and time" },
                ]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm"
                  showTime={{ format: "HH:mm" }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                label={<label className="fw-medium">Lead Remark</label>}
                name="remarks"
                className="mb15"
                rules={[
                  { required: true, message: "Please enter a note" },
                  { min: 10, message: "Note must be at least 10 characters" },
                  { max: 500, message: "Note can’t exceed 500 characters." },
                ]}
              >
                <TextArea
                  rows={5}
                  maxLength={500}
                  placeholder="Type your remark…"
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="mt-3 d-flex gap-20 align-items-center justify-content-end">
            <Button className="secondary-btn" onClick={redirectToTimline}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="theme-btn">
              Save
            </Button>
          </div>
        </Form>
        <ActivityTime setActiveTab={setActiveTab} />
      </div>
    </>
  );
};

export default Tasks;
